import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

function PlumbingElectricalSystems() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?fm=webp&q=70&auto=format&fit=max&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Plumbing, Electrical & <span className="text-gold">Essential Systems</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Vital building systems installed with meticulous precision to the highest safety standards
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              The mechanical, electrical, and plumbing systems are the lifeblood of any building. Williams Diversified provides comprehensive MEP installation services, ensuring all essential systems are installed correctly, efficiently, and to code.
            </p>
            <p>
              Our licensed technicians and certified electricians bring expertise to every project, from basic installations to complex commercial systems. We prioritize safety, reliability, and long-term performance in all our work.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Expertise</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Commercial plumbing systems</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Electrical installation and wiring</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>HVAC systems installation</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Fire protection systems</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Building automation integration</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Emergency power systems</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Let's Discuss Your <span className="text-gold">System Needs</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default PlumbingElectricalSystems;